/* eslint-disable */
import React from 'react';
import { withRouter } from 'react-router';
import { StyleSheet, css } from 'aphrodite/no-important';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import '../assets/styles/class.scss';

import { pages } from '../global/constants';

@observer
class Volume extends React.Component {
  toSoulAll = () => {
    const { history } = this.props;
    history.push(pages.SOUL);
  };

  render() {
    const { isMuted, setMuted } = this.props;

    return (
      <div className={`volume ${css(styles.flex, styles.flex_layout)}`}>
        <h5
          className={`${css(
            styles.highlights,
            styles.highlights_layout
          )} cursor-pointer soul`}
        >
          <a style={{ color: 'inherit' }} href="/soul">
            {'五感靈魂樣貌'}
          </a>
        </h5>
        <div className={css(styles.flex_spacer)} />
        <div className={css(styles.flex_item)}>
          <div
            style={{
              '--src': `url(${
                require('assets/031659d0b68243202995fa0cab936b4a.png').default
              })`
            }}
            className={clsx([
              `${css(styles.image, styles.image_layout)} cursor-pointer muted`,
              {
                active: isMuted
              }
            ])}
            onClick={setMuted}
          />
        </div>
        <div className={css(styles.flex_spacer1)} />
      </div>
    );
  }
}

export default withRouter(Volume);

Volume.inStorybook = true;

const styles = StyleSheet.create({
  flex: {
    display: 'flex'
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1,
    '@media (max-width: 991.98px)': {
      margin: 0
    }
  },
  highlights: {
    display: 'flex',
    alignItems: 'center',
    font: '16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px'
  },
  highlights_layout: {
    flex: '0 0 auto',
    margin: '0.5px 0px'
  },
  flex_spacer: {
    flex: '1 1 919px'
  },
  flex_item: {
    display: 'flex',
    position: 'relative',
    flex: '0 0 auto',
    minWidth: 24
  },
  image: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image_layout: {
    height: 21,
    width: 24,
    minWidth: 24,
    margin: '4px 0px'
  },
  flex_spacer1: {
    flex: '0 1 67px'
  }
});
